export default {
      id: "icon-profile-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-profile",
      toString: function () {
        return this.url;
      }
    }